import { render } from "./SolicitudesViajero.vue?vue&type=template&id=0fabcb95"
import script from "./SolicitudesViajero.vue?vue&type=script&lang=js"
export * from "./SolicitudesViajero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__